import { connect } from 'react-redux'

import { setFeedback, postFeedback } from 'reduxpath/ducks/Project/Pitch'

import Feedback from './units'


const mapStateToProps = (state) => {
  const feedbacks = state.ProjectPitch.feedback.rows
  const { ProjectPitch, Auth } = state
  const gcProfile = Auth.me.profiles
    .filter(p => p.profileId === 'getcraft')

  return {
    feedbacks,
    pitch: ProjectPitch.servicePitch.id,
    order: ProjectPitch.servicePitch.order,
    say: ProjectPitch.inputFeedback,
    admin: {
      user: Auth.me.user.id,
      profile: gcProfile.length > 0 && gcProfile[0].id,
      profileId: 'getcraft',
    },
  }
}

const mapDispatchToProps = dispatch => ({
  handleSubmitFeedback(pitch, admin, say, order) {
    return (e) => {
      e.preventDefault()
      const params = {
        ...admin,
        pitch,
        say: `<p>${say}</p>`,
      }
      dispatch(postFeedback(params, () => window.location.replace(`/projects/${order}/pitch/${pitch}`)))
    }
  },
  handleChangeFeedback(e) {
    dispatch(setFeedback(e.target.value))
  },
})

const mergeProps = (stateProps, dispatchProps) => ({

  ...stateProps,
  ...dispatchProps,
  handleSubmitFeedback: dispatchProps.handleSubmitFeedback(
    stateProps.pitch,
    stateProps.admin,
    stateProps.say,
    stateProps.order,
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Feedback)
